import FormContentIdAndHash from '../../../domain/form/FormContentIdAndHash'
import formsBaseUrl from './baseUrl'
import bearerTokenHeader from '../authorization/bearerTokenHeader'
import { com } from '@eidu/form'
import requireAuthContext from '../authorization/requireAuthContext'
import FormContent = com.eidu.sharedlib.form.FormContent
import formContentIdFromString = com.eidu.sharedlib.entity.kind.form.formContentIdFromString
import CreateFormRequest = com.eidu.sharedlib.form.CreateFormRequest
import encodeCreateFormRequestToJson = com.eidu.sharedlib.form.encodeCreateFormRequestToJson

type PostFormParameters = {
  formId: string
  initialContent: FormContent
}

const postForm = async ({ formId, initialContent }: PostFormParameters): Promise<FormContentIdAndHash> => {
  const authContext = await requireAuthContext()
  const request = encodeCreateFormRequestToJson(new CreateFormRequest(formId, initialContent))
  const response = await fetch(`${formsBaseUrl}/organizations/${authContext.organizationId}/forms`, {
    method: 'POST',
    headers: {
      ...bearerTokenHeader(authContext.accessToken),
      'Content-Type': 'application/json',
    },
    body: request,
  })
  const responseJson = await response.json()
  if (response.status !== 200) throw Error(responseJson.message)

  return { contentId: formContentIdFromString(responseJson.contentId), contentSha256: responseJson.contentSha256 }
}

export default postForm
